import { Paper, Skeleton, Stack } from '@mui/material';
import { styled } from '@mui/material/styles';

export function ExpertProfilePageSkeleton() {
  return (
    <Wrapper aria-busy="true" aria-label="Loading profile">
      <SkeletonPaper variant="outlined">
        <SkeletonProfileRow>
          <SkeletonAvatar variant="circular" />
          <SkeletonContentCol>
            <Skeleton variant="text" width="60%" height={32} />
            <Skeleton variant="text" width="40%" height={20} />
            <Skeleton variant="text" width="70%" height={20} />
          </SkeletonContentCol>
        </SkeletonProfileRow>
      </SkeletonPaper>
      <SkeletonPaper variant="outlined">
        <Skeleton variant="text" width="30%" height={28} />
        <SkeletonFeeRow>
          <Skeleton variant="text" width={80} height={24} />
          <Skeleton variant="text" width={80} height={24} />
          <Skeleton variant="text" width={80} height={24} />
          <Skeleton variant="text" width={80} height={24} />
        </SkeletonFeeRow>
      </SkeletonPaper>
      <SkeletonPaper variant="outlined">
        <Skeleton variant="text" width="40%" height={28} />
        <Skeleton variant="text" width="100%" height={48} />
      </SkeletonPaper>
      <SkeletonPaper variant="outlined">
        <Skeleton variant="text" width="50%" height={28} />
        <SkeletonTablePlaceholder>
          <Skeleton variant="text" width="100%" height={24} />
          <Skeleton variant="text" width="100%" height={24} />
          <Skeleton variant="text" width="100%" height={24} />
        </SkeletonTablePlaceholder>
      </SkeletonPaper>
    </Wrapper>
  );
}

const Wrapper = styled(Stack)(() => ({
  flexDirection: 'column',
  alignItems: 'stretch',
  minHeight: 200,
}));

const SkeletonPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(3),
  marginBottom: theme.spacing(3),
}));

const SkeletonProfileRow = styled(Stack)(({ theme }) => ({
  flexDirection: 'column',
  gap: theme.spacing(3),
  alignItems: 'center',
  [theme.breakpoints.up('md')]: {
    flexDirection: 'row',
    alignItems: 'flex-start',
  },
}));

const SkeletonAvatar = styled(Skeleton)({
  width: 96,
  height: 96,
  flexShrink: 0,
});

const SkeletonContentCol = styled(Stack)(({ theme }) => ({
  minWidth: 0,
  flex: 1,
  width: '100%',
  flexDirection: 'column',
  gap: theme.spacing(1),
  alignItems: 'center',
  [theme.breakpoints.up('md')]: {
    alignItems: 'flex-start',
  },
}));

const SkeletonFeeRow = styled(Stack)(({ theme }) => ({
  flexDirection: 'row',
  flexWrap: 'wrap',
  gap: theme.spacing(2),
  marginTop: theme.spacing(1),
}));

const SkeletonTablePlaceholder = styled(Stack)(({ theme }) => ({
  flexDirection: 'column',
  gap: theme.spacing(1),
  marginTop: theme.spacing(1),
}));
